module.exports = __webpack_public_path__ + "img/slide8-tronic.98d4dd34.png";